
import {
    useState
} from 'react';
import Modal from '../utils/Modal';

import '../component.css';
import process_vars from '../intermediate/process_vars';

import ScriptView from '../script/ScriptView';
import ElementFrame from '../utils-components/ElementFrame';
import PropSection from '../utils-components/PropSection';

export default function Radio({ id, comps, setter, vw, gridSize, sel, setSel, hov, setHov, vars, setVars, contextMenu, setContextMenu, pdf, magneticGrid, setMagneticGrid, magneticGridPartitions }) {

    let background_color = '';
    if (hov === id) {
        background_color = '#e8f1ff';
    } else {
        background_color = process_vars(comps[id].props.backgroundColor, vars);
    }

    let innerContent = [];
    if (sel === id)
        background_color = process_vars(comps[id].props.backgroundColor, vars);
    for (let k = 0; k < comps[id].props.content.length; ++k) {
        let left_margin = '0.5vmax';
        if (process_vars(comps[id].props.alignment === 'center')) {
            left_margin = '40%';
        } else if (process_vars(comps[id].props.alignment === 'right')) {
            left_margin = '80%';
        }
        if (pdf == true) {

            if (k === parseInt(comps[id].props.selected)) {
                innerContent.push(" ☑ " + comps[id].props.content[k]);
            }
            else {
                innerContent.push(" ☐ " + comps[id].props.content[k]);
            }
        } else {
            innerContent.push(
                <div style={{
                    display: 'flex',
                    width: '100%',
                    height: (100 / comps[id].props.content.length).toString() + '%',
                    alignItems: "center"
                }}>
                    <input type='radio' style={{
                        marginLeft: left_margin
                    }}
                        id={`radio-${id}-${k}`}
                        value={process_vars(comps[id].props.content[k], vars)}
                        checked={k === parseInt(comps[id].props.selected)} />
                    <label style={{
                        marginLeft: '0.5vmax'
                    }}
                        for={`radio-${id}-${k}`}>
                        {process_vars(comps[id].props.content[k], vars)}
                    </label>
                </div>
            );
        }
    }
    console.log('innerContent1 > ', innerContent);

    return (
        <div>
            <ElementFrame id={id} comps={comps} setter={setter} vw={vw}
                gridSize={gridSize} vars={vars} setSel={setSel} setHov={setHov}
                setContextMenu={setContextMenu} magneticGrid={magneticGrid}
                magneticGridPartitions={magneticGridPartitions} preset="small"
                style={{
                    whiteSpace: pdf == true ? 'pre-line' : 'initial',
                    color: process_vars(comps[id].props.color, vars),
                    overflow: 'hidden',
                    fontSize: process_vars(comps[id].props.fontSize, vars) + 'vmax',
                    fontWeight: process_vars(comps[id].props.bold, vars) ? '700' : '400',
                    fontStyle: process_vars(comps[id].props.italic, vars) ? 'italic' : '',
                    textDecoration: process_vars(comps[id].props.underlined, vars) ? 'underline' : '',
                    zIndex: '0',
                    paddingLeft: 5,
                    border: process_vars(comps[id].props.borderEnabled, vars) ?
                        `${process_vars(comps[id].props.borderColor, vars)} solid ${process_vars(comps[id].props.borderWidth)}pt` : '#000 solid 0px',
                    transition: 'transform 0.05s ease'
                }}>
                {
                    pdf == true ? (innerContent.join('\n')) : (
                        <div>{innerContent}</div>
                    )
                }
            </ElementFrame>
        </div>
    );

}

export function RadioProperties({ id, comps, setter, setSel, vars, setVars, externals, setExternals, creationIndex, setCreationIndex }) {

    const [editing, setEditing] = useState(false);

    let init_selected_content = [
        <option value='-1'>None</option>
    ];
    for (let k = 0; k < comps[id].props.content.length; ++k) {
        init_selected_content.push(
            <option value={k}>{process_vars(comps[id].props.content[k], vars)}</option>
        )
    }

    const [isShowingScript, setIsShowingScript] = useState(false);

    return (<>
        <div className="prop-actions">
            <a className='panel-button' onClick={(e) => {
                e.preventDefault();
                setIsShowingScript(true);
            }}>Edit Script</a>
        </div>

        <PropSection title="Layout">
            <p className='panel-label'>Position: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].position[0] = e.target.value;
                setter(new_comps);
            }} value={comps[id].position[0]} style={{ width: '25%' }} placeholder='X' />
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].position[1] = e.target.value;
                setter(new_comps);
            }} value={comps[id].position[1]} style={{
                width: '25%',
                marginLeft: '0.5vmax'
            }} placeholder='Y' />
            <br /> <br />
            <p className='panel-label'>Dimensions: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].size[0] = e.target.value;
                setter(new_comps);
            }} value={comps[id].size[0]} style={{ width: '25%' }} placeholder='Width' />
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].size[1] = e.target.value;
                setter(new_comps);
            }} value={comps[id].size[1]} style={{
                width: '25%',
                marginLeft: '0.5vmax'
            }} placeholder='Height' />
        </PropSection>

        <PropSection title="Content">
            <p className='panel-label'>Content: </p>
            <a className='panel-button' onClick={(e) => {
                e.preventDefault();
                setEditing(true);
            }}>Open Edit Modal</a>
            <br /> <br />
            <p className='panel-label'>Initial Selected: </p>
            <select name="init_selected" id="init_selected" className='panel-dropdown' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.selected = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.selected}>
                {init_selected_content}
            </select>
        </PropSection>

        <PropSection title="Text">
            <p className='panel-label'>Size: </p>
            <input className='panel-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.fontSize = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.fontSize} />
            <br /> <br />
            <p className='panel-label'>Style: </p>
            <i className={'fa fa-solid fa-bold panel-icon' + (comps[id].props.bold ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.bold = !new_comps[id].props.bold;
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-italic panel-icon' + (comps[id].props.italic ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.italic = !new_comps[id].props.italic;
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-underline panel-icon' + (comps[id].props.underlined ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.underlined = !new_comps[id].props.underlined;
                setter(new_comps);
            }}></i>
            <br /> <br />
            <p className='panel-label'>Alignment: </p>
            <i className={'fa fa-solid fa-align-left panel-icon' + (comps[id].props.alignment === 'left' ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.alignment = 'left';
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-align-center panel-icon' + (comps[id].props.alignment === 'center' ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.alignment = 'center';
                setter(new_comps);
            }}></i>
            <i className={'fa fa-solid fa-align-right panel-icon' + (comps[id].props.alignment === 'right' ? ' prop-toggle-active' : '')} onClick={() => {
                let new_comps = [...comps];
                new_comps[id].props.alignment = 'right';
                setter(new_comps);
            }}></i>
            <br /> <br />
            <p className='panel-label'>Text Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.color = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.color} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.color = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.color} />
        </PropSection>

        <PropSection title="Appearance">
            <p className='panel-label'>Background Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.backgroundColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.backgroundColor} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.backgroundColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.backgroundColor} />
        </PropSection>

        <PropSection title="Border">
            <p className='panel-label'>Border Enabled: </p>
            <input type="checkbox" checked={comps[id].props.borderEnabled} onClick={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderEnabled = !new_comps[id].props.borderEnabled;
                setter(new_comps);
            }}></input>
            <br /><br />
            <p className='panel-label'>Border Color: </p>
            <input className='panel-input' style={{
                width: '17.5%',
                marginRight: '0.75vmax'
            }} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.borderColor} />
            <p className='panel-label'>or</p>
            <input type='color' className='panel-color-input' onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderColor = e.target.value;
                setter(new_comps);
            }} value={comps[id].props.borderColor} />
            <br /><br />
            <p className='panel-label'>Border Width:</p>
            <input type='range' min='1' max='10' value={comps[id].props.borderWidth} onChange={(e) => {
                let new_comps = [...comps];
                new_comps[id].props.borderWidth = parseInt(e.target.value);
                setter(new_comps);
            }}></input>
        </PropSection>

        <div className="prop-footer">
            <a className='panel-button' onClick={(e) => {
                e.preventDefault();
                setSel(-1);
            }}>Ok</a>
            <a className='panel-button prop-danger' onClick={(e) => {
                e.preventDefault();
                let new_comps = [...comps];
                new_comps.splice(id, 1);
                setSel(-1);
                setter(new_comps);
            }}>Delete</a>
        </div>

        {editing ?
            <RadioContentMenu id={id} comps={comps} setter={setter} setEditing={setEditing} /> :
            <></>
        }
        {isShowingScript && !editing ? <ScriptView id={id} comps={comps} setComps={setter}
            setIsShowingScript={setIsShowingScript}
            vars={vars} setVars={setVars} externals={externals} setExternals={setExternals}
            creationIndex={creationIndex} setCreationIndex={setCreationIndex} /> : <></>}
    </>);

}

export function RadioAdder({ comps, setComps, setView, page, pageId, setSelectedEl, creationIndex, setCreationIndex }) {

    const [hovered, setHovered] = useState(false);

    return (
        <div className="toolbar-element" style={{
            // border: '1px #FAF3DD solid',
            // display: 'inline-block',
            // padding: '1vmax',
            // color: '#1f2933',
            // backgroundColor: hovered ? '#FAF3DD' : 'black',
            // transition: 'background-color 0.1s, color 0.1s',
            // marginLeft: '1vmax'
        }} onMouseEnter={() => {
            setHovered(true);
        }} onMouseLeave={() => {
            setHovered(false);
        }} onClick={(e) => {
            e.preventDefault();
            let new_comps = [...comps];
            new_comps.push({
                page: page,
                page_id: pageId,
                type: 'primitive/Radio',
                name: 'Radio',
                ...(creationIndex != -1 && { creation_index: creationIndex }),
                position: [0.475, 0.15 + document.getElementById("wrapper").scrollTop / document.getElementById("wrapper").offsetWidth],
                size: [0.10, 0.05],
                props: {
                    content: [
                        'Radio'
                    ],
                    selected: '',
                    fontSize: '1',
                    bold: false,
                    italic: false,
                    underlined: false,
                    color: '#000000',
                    backgroundColor: '#ffffff',
                    alignment: 'left',
                    borderEnabled: true,
                    borderColor: '#000000',
                    borderWidth: 1
                }, script: [
                    {
                        type: "event/start",
                        children: []
                    },
                    {
                        type: "event/change",
                        children: []
                    },
                    {
                        type: "event/save",
                        children: []
                    }
                ],
                error: "",
                warning: "",
                disable: false
            });
            if (creationIndex != -1) {
                setCreationIndex(creationIndex + 1);
            }
            setComps(new_comps);
            setView('');
            setSelectedEl(comps.length);
        }}>
            <i className="fa fa-solid fa-dot-circle-o" style={{
                color: '#7c3aed'
            }}></i>
            <p className='panel-label' style={{
                color: '#1f2933',
                marginLeft: '1vmax',
                fontSize: '1.15vmax'
            }}>Radio</p>
        </div>
    );

}

export function RadioContentMenu({ id, comps, setter, setEditing }) {

    const [del, setDel] = useState(false);

    let content_list = [];
    for (let k = 0; k < comps[id].props.content.length; k++) {
        content_list.push(
            <div className="prop-row-card" style={{
                padding: '0.5vmax',
                textAlign: 'justify',
                margin: '2vmax 2vmax 0 2vmax',
                marginTop: k !== 0 ? '' : '2vmax'
            }}>
                <div style={{
                    display: 'inline-block',
                    width: '70%'
                }}>
                    <i className="fa fa-solid fa-circle-dot prop-row-icon" style={{
                        fontSize: '1.25vmax',
                        margin: '0 1vmax 0 0.5vmax'
                    }}></i>
                    <input className='panel-input' style={{
                        fontWeight: '300',
                        fontSize: '1.25vmax',
                        width: '60%',
                        padding: '0px 5px',
                        height: 25
                    }} value={comps[id].props.content[k]} onChange={(e) => {
                        let new_comps = [...comps];
                        new_comps[id].props.content[k] = e.target.value;
                        setter(new_comps);
                    }}></input>
                </div>
                <div style={{
                    display: 'inline-block',
                    width: '30%'
                }}>
                    <i className="fa fa-solid fa-angle-down pointy prop-row-icon" style={{
                        fontSize: '1.25vmax',
                        margin: '0 1vmax 0 0vmax'
                    }} onClick={() => {
                        if (k !== comps[id].props.content.length - 1) {
                            let new_comps = [...comps];
                            let current = new_comps[id].props.content[k];
                            new_comps[id].props.content[k] = new_comps[id].props.content[k + 1];
                            new_comps[id].props.content[k + 1] = current;
                            setter(new_comps);
                        }
                    }}></i>
                    <i className="fa fa-solid fa-angle-up pointy prop-row-icon" style={{
                        fontSize: '1.25vmax',
                        margin: '0 0vmax 0 0vmax'
                    }} onClick={() => {
                        if (k !== 0) {
                            let new_comps = [...comps];
                            let current = new_comps[id].props.content[k];
                            new_comps[id].props.content[k] = new_comps[id].props.content[k - 1];
                            new_comps[id].props.content[k - 1] = current;
                            setter(new_comps);
                        }
                    }}></i>
                    <i className="fa fa-solid fa-trash pointy prop-row-icon prop-danger" style={{
                        fontSize: '1.25vmax',
                        margin: '0 0vmax 0 2vmax'
                    }} onClick={() => {
                        let new_comps = [...comps];
                        new_comps[id].props.content.splice(k, 1);
                        setter(new_comps);
                    }}></i>
                </div>
            </div>
        );
    }

    return (
        <>
            <Modal width={45} height={50} light>
                <h1 style={{
                    fontWeight: '300',
                    margin: '0',
                    padding: '1vmax 0',
                    fontSize: '1.75vmax',
                    borderBottom: '1px solid',
                    display: 'block'
                }}>Edit Radio Element</h1>
                <div style={{
                    height: 'calc(100% - 100px)',
                    overflowY: 'auto'
                }}>
                    {content_list}
                    <br /> <br /> <br />
                </div>
                <div className="prop-modal-footer" style={{
                    position: 'absolute',
                    bottom: '0',
                    width: '100%',
                    borderTop: '1px solid'
                }}>
                    <a href='' className='panel-button' style={{
                        margin: '1vmax'
                    }} onClick={(e) => {
                        e.preventDefault();
                        let new_comps = [...comps];
                        new_comps[id].props.content.push(`New Option ${new_comps[id].props.content.length + 1}`);
                        setter(new_comps);
                    }}>Add Option</a>
                    <a href='' className='panel-button' style={{
                        marginBottom: '1vmax'
                    }} onClick={(e) => {
                        e.preventDefault();

                        // trim start and end spaces all list elements
                        // this will ensure strings like ' hello, world!    ' will become 'hello, world!'
                        let new_comps = [...comps];
                        for (let k = 0; k < new_comps[id].props.content.length; ++k) {
                            new_comps[id].props.content[k] = new_comps[id].props.content[k].trim();
                        }
                        setter(new_comps);

                        setEditing(false);
                    }}>Exit</a>
                </div>
            </Modal>
        </>
    );

}